import { useTranslation } from '@pancakeswap/localization'
import { Link } from '@pancakeswap/uikit'
import { styled } from 'styled-components'

/* ===== 社交图标 ===== */
const XIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
)

const TelegramIconSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
)

const DiscordIconSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
  </svg>
)

const InstagramIconSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
)

const MediumIconSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M13.54 12a6.8 6.8 0 0 1-6.77 6.82A6.8 6.8 0 0 1 0 12a6.8 6.8 0 0 1 6.77-6.82A6.8 6.8 0 0 1 13.54 12zm7.42 0c0 3.54-1.51 6.42-3.39 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.39 2.88 3.39 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z" />
  </svg>
)

const YoutubeIconSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
)

const socialIconsMap: Record<string, React.ReactNode> = {
  x: <XIcon />,
  telegram: <TelegramIconSvg />,
  discord: <DiscordIconSvg />,
  medium: <MediumIconSvg />,
  instagram: <InstagramIconSvg />,
  youtube: <YoutubeIconSvg />,
}

/* ===== Styled Components ===== */
const SiteFooter = styled.footer`
  position: relative;
  z-index: 2;
  width: 100%;
  background: ${({ theme }) => theme.colors.background};
  border-top: 1px solid ${({ theme }) => theme.colors.cardBorder};
  padding: 32px 0 20px;
  color: ${({ theme }) => theme.colors.text};
  font-family: 'Inter', system-ui, -apple-system, sans-serif;

  ${({ theme }) => theme.mediaQueries.md} {
    padding: 56px 0 28px;
  }
`

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 0 2rem;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0 4rem;
  }
`

const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 24px;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.md} {
    gap: 48px;
    margin-bottom: 40px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    flex-direction: row;
  }
`

const FooterBrand = styled.div`
  max-width: 260px;
`

const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;

  img {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    object-fit: contain;
  }

  span {
    font-weight: 700;
    font-size: 0.95rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.text};
  }
`

const FooterDesc = styled.p`
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 16px;
  margin-top: 0;
`

const FooterSocials = styled.div`
  display: flex;
  gap: 14px;
`

const FooterSocial = styled(Link)`
  width: 40px;
  height: 40px;

  @media (min-width: 480px) {
    width: 48px;
    height: 48px;
  }
  flex-shrink: 0;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.input};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  text-decoration: none;
  color: #6b7280;

  &:hover {
    background: ${({ theme }) => (theme.isDark ? 'rgba(95, 203, 130, 0.1)' : 'rgba(233, 30, 99, 0.1)')};
    border-color: ${({ theme }) => (theme.isDark ? 'rgba(95, 203, 130, 0.3)' : 'rgba(233, 30, 99, 0.3)')};
    transform: translateY(-3px);
    box-shadow: ${({ theme }) => (theme.isDark ? '0 8px 24px rgba(95, 203, 130, 0.15)' : '0 8px 24px rgba(233, 30, 99, 0.15)')};
    color: ${({ theme }) => theme.colors.primary};
  }
`

const FooterLinks = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    gap: 24px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    display: flex;
    gap: 48px;
    flex-wrap: nowrap;
  }
`

const FooterCol = styled.div`
  min-width: 120px;

  h4 {
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 14px;
    margin-top: 0;
    text-transform: uppercase;
  }

  a {
    display: block;
    font-size: 0.9rem;
    color: #6b7280;
    padding: 3px 0;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`

const FooterBottom = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.cardBorder};
  padding-top: 20px;
  text-align: center;

  p {
    font-size: 0.7rem;
    color: #9ca3af;
    font-family: 'Space Mono', monospace;
    margin: 0;
  }
`

interface FooterLinkItem {
  label: string
  href: string
}

interface FooterColumn {
  title: string
  links: FooterLinkItem[]
}

const defaultColumns: FooterColumn[] = []

const socials = [
  { icon: 'x', href: 'https://x.com/MetaAsset_MA' },
  { icon: 'telegram', href: 'https://t.me/metaassets_ma' },
  { icon: 'discord', href: 'https://discord.gg/xmfWWAUphm' },
  { icon: 'medium', href: 'https://medium.com/@MetaAssets' },
  { icon: 'instagram', href: 'https://www.instagram.com/metaassets_ma/' },
  { icon: 'youtube', href: 'https://www.youtube.com/@MetaAsset_MA' },
]

const Footer = () => {
  const { t } = useTranslation()

  return (
    <SiteFooter>
      <FooterInner>
        <FooterTop>
          <FooterBrand>
            <FooterLogo>
              <img src="/images/logo_white_bg.png" alt="MacSwap" />
              <span>MacSwap</span>
            </FooterLogo>
            <FooterDesc>{t('The friendliest DEX on MA-Chain. Swap, earn, and grow your crypto with ease.')}</FooterDesc>
            <FooterSocials>
              {socials.map((s) => (
                <FooterSocial key={s.icon} href={s.href} external aria-label={s.icon}>
                  {socialIconsMap[s.icon]}
                </FooterSocial>
              ))}
            </FooterSocials>
          </FooterBrand>
          {defaultColumns.length > 0 && (
            <FooterLinks>
              {defaultColumns.map((col) => (
                <FooterCol key={col.title}>
                  <h4>{t(col.title)}</h4>
                  {col.links.map((link) => (
                    <Link key={link.label} href={link.href} external={link.href.startsWith('http')} color="textSubtle">
                      {t(link.label)}
                    </Link>
                  ))}
                </FooterCol>
              ))}
            </FooterLinks>
          )}
        </FooterTop>
        <FooterBottom>
          <p>&copy; 2025 MacSwap. All rights reserved.</p>
        </FooterBottom>
      </FooterInner>
    </SiteFooter>
  )
}

export default Footer
